"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StockCount = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = require("b2b-components/theme/components/Tooltip");
var _device = require("b2b-components/utils/device");
var _classnames = _interopRequireDefault(require("classnames"));
var _TooltipContent = require("./TooltipContent");
require("./StockCount.scss");
var StockCount = function StockCount(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    stockCount = _ref.stockCount,
    tooltipLabel = _ref.tooltipLabel,
    _ref$deviceType = _ref.deviceType,
    deviceType = _ref$deviceType === void 0 ? _device.DEVICE_TYPE.desktop : _ref$deviceType,
    _ref$isFullSize = _ref.isFullSize,
    isFullSize = _ref$isFullSize === void 0 ? false : _ref$isFullSize,
    _ref$hasTooltip = _ref.hasTooltip,
    hasTooltip = _ref$hasTooltip === void 0 ? true : _ref$hasTooltip,
    _ref$isSpecialOrder = _ref.isSpecialOrder,
    isSpecialOrder = _ref$isSpecialOrder === void 0 ? false : _ref$isSpecialOrder,
    _ref$quantityOrdered = _ref.quantityOrdered,
    quantityOrdered = _ref$quantityOrdered === void 0 ? null : _ref$quantityOrdered,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      date: 'Date',
      deliveryDates: 'Expected delivery date',
      notReadyForShipment: 'Not ready for shipment',
      orderedQuantity: 'Ordered Quantity',
      readyForShipment: 'pc. ready for shipment',
      unknownDeliveryDate: 'Unknown delivery date',
      specialOrder: {
        full: 'Special Order',
        "short": 'S.O.',
        explanation: 'We do not stock this item.'
      },
      seeMore: 'see more'
    } : _ref$text;
  var rootClassName = (0, _classnames["default"])('cds-StockCount', {
    'cds-StockCount--Negative': !isSpecialOrder && stockCount <= 0,
    'cds-StockCount--WithTooltip': hasTooltip
  }, className);
  var label = tooltipLabel;
  if (!label) {
    if (isSpecialOrder && stockCount <= 0) {
      label = isFullSize ? text.specialOrder.full : text.specialOrder["short"];
    } else if (stockCount > 0) {
      label = "+".concat(stockCount);
    } else {
      label = stockCount;
      if (isFullSize) {
        label = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label, "\xA0", /*#__PURE__*/_react["default"].createElement("span", {
          className: "cds-StockCount-MoreInfo"
        }, "(", text.seeMore, ")"));
      }
    }
  }
  var stockCountLabelElement = onClick ? /*#__PURE__*/_react["default"].createElement("span", {
    onClick: onClick
  }, label) : label;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: rootClassName
  }, !hasTooltip && stockCountLabelElement, hasTooltip && /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
    content: /*#__PURE__*/_react["default"].createElement(_TooltipContent.TooltipContent, {
      quantityOrdered: quantityOrdered,
      stockCount: stockCount,
      text: text,
      isSpecialOrder: isSpecialOrder
    }),
    isHoverable: deviceType === _device.DEVICE_TYPE.desktop
  }, stockCountLabelElement));
};
exports.StockCount = StockCount;